import { render } from "./ChangePassword.vue?vue&type=template&id=78de1422"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=78de1422&lang=css"
script.render = render

export default script